<script>
import Container from '@/components/Container'
import Tile from '@/components/Tile'
import ReportSave from '@/components/ReportSave'
import ReportSchedule from '@/components/ReportSchedule'
import ReportFavorite from '@/components/ReportFavorite'
import { GChart } from 'vue-google-charts/legacy'
import html2pdf from 'html2pdf.js'
import XLSX from 'xlsx-js-style'

export default {
  name: 'ReportResults',
  props: {
    reportName: { required: true, type: String },
    reportRecords: { required: true, type: Array },
    reportFields: { type: Array },
    reportParameters: { type: Object },
    reportDetails: { reuired: true, type: Object },
    chartTypes: {
      type: Array,
      default: () => {
        return ['table']
      }
    },
    chartType: { type: String },
    allowDownload: { type: Boolean, default: true },
    allowSave: { type: Boolean, default: true },
    allowFavorite: { type: Boolean, default: true },
    inTile: { type: Boolean, default: false },
    allowActions: { type: Boolean, default: false }
  },
  components: {
    ReportSave,
    ReportFavorite,
    GChart,
    Container,
    ReportSchedule,
    Tile
  },
  data() {
    return {
      resultsCurrentPage: 1,
      resultsPerPage: localStorage.reportResultsPerPage || 25,
      currentChartType: 'table',
      tableFilter: '',
      prePDFResultsPerPage: 0,
      gchartReady: false,
      savedData: null,
      publicLink: '',
      actionPerformedIndex: 0
    }
  },
  watch: {
    reportRecords: function() {
      console.log('here')
    },
    chartType: function() {
      this.currentChartType = this.chartType
    },
    resultsPerPage: function() {
      localStorage.reportResultsPerPage = this.resultsPerPage
    }
  },
  computed: {
    gchartData() {
      let data = [[]]
      this.reportFields.forEach(field => data[0].push(this.getLabel(field)))
      this.reportRecords.forEach(record => {
        let chartRecord = []
        this.reportFields.forEach(field =>
          chartRecord.push(
            field.type == 'numeric'
              ? parseFloat(
                  record[field.key || field.field || field.name || field] || 0
                )
              : record[field.key || field.field || field.name || field]
          )
        )
        data.push(chartRecord)
      })
      return data
    },
    gchartOptions() {
      return (
        {
          donut: {
            title: this.reportName,
            pieHole: 0.4
          },
          curve: {
            title: this.reportName,
            curveType: 'function'
          }
        }[this.currentChartType] || {
          chart: {
            title: this.reportName
          },
          title: this.reportName
        }
      )
    },
    gchartSettings() {
      return {}[this.currentChartType] || {}
    },
    gchartType() {
      return {
        bar: 'ColumnChart',
        pie: 'PieChart',
        area: 'AreaChart',
        donut: 'PieChart',
        line: 'LineChart',
        curve: 'LineChart'
      }[this.currentChartType]
    },
    chartTypeOptions() {
      return [
        { value: 'tiles', text: 'Tiles' },
        { value: 'tile', text: 'Tile' },
        { value: 'table', text: 'Table' },
        { value: 'simpleTable', text: 'Simple Table' },
        { value: 'bar', text: 'Bar Chart' },
        { value: 'pie', text: 'Pie Chart' },
        { value: 'area', text: 'Area Chart' },
        { value: 'donut', text: 'Donut Chart' },
        { value: 'line', text: 'Line Chart' },
        { value: 'curve', text: 'Curved Line Chart' }
      ].filter(
        option =>
          this.chartTypes.includes(option.value) &&
          (option.value != 'table' || this.tableFieldRows.length == 1)
      )
    },
    tableFields() {
      return this.reportFields
        ? this.reportFields
            .filter(
              field =>
                (typeof field.show == 'undefined' || field.show) &&
                (this.allowActions || field.key != 'actionPerformed')
            )
            .map(field => ({
              formatter: (value, key, item, fromExport) => {
                if (field.type == 'links') {
                  return value && value.length
                    ? value
                        .map(
                          val =>
                            `<a href="${val.link}" target="_blank">${val.text}</a>`
                        )
                        .join('<br />')
                    : null
                }
                //return value ? value.value || value : value
                return this.buildResultField(field).formatter(
                  value ? value.value || value : value,
                  key,
                  item,
                  fromExport
                )
              },
              sortable: true,
              sortByFormatted: true,
              ...field
            }))
        : null
    },
    tableFieldRows() {
      let rows = [[]]
      this.tableFields.forEach(field => {
        if (field.row) {
          while (rows.length < field.row) {
            rows.push([])
          }
          rows[field.row - 1].push(field)
        } else {
          rows[0].push(field)
        }
      })
      return rows
    },
    tableData() {
      return this.reportRecords.map(record => ({
        _cellVariants: Object.fromEntries(
          Object.entries(record)
            .filter(([, val]) => val && val.color && val.color != 'black')
            .map(([key, val]) => [
              key,
              {
                green: 'success',
                blue: 'primary',
                yellow: 'warning',
                orange: 'warning',
                red: 'danger'
              }[val.color] || val
            ])
        ),
        ...record
      }))
    },
    fullFormRecord() {
      return {
        ...this.reportParameters,
        ...this.reportRecords[0]
      }
    },
    tiles() {
      return this.reportFields.filter(
        field =>
          this.showHideVIf(field) &&
          (typeof field.tile == 'undefined' || field.tile)
      )
    }
  },
  methods: {
    generatePDF() {
      this.prePDFResultsPerPage = this.resultsPerPage
      this.resultsPerPage = 10000
      this.$refs.reportDiv.style.width = '100px'
      this.$refs.reportDiv.style.width =
        Math.max(
          1000,
          this.$refs.reportDiv.querySelector('table')
            ? this.$refs.reportDiv.querySelector('table').offsetWidth
            : 1000
        ) + 'px'
      return html2pdf()
        .set({
          filename: `${this.reportName}.pdf`,
          margin: 5,
          image: { type: 'jpeg', quality: 0.95 },
          jsPDF: { format: 'letter', unit: 'px', hotfixes: ['px_scaling'] },
          html2canvas: {
            width: this.$refs.reportDiv.offsetWidth,
            dpi: 192,
            letterRendering: true,
            ignoreElements: element =>
              element.classList.contains('hide-on-print')
          }
        })
        .from(this.$refs.reportDiv)
    },
    afterPDF() {
      this.$refs.reportDiv.style.width = null
      this.resultsPerPage = this.prePDFResultsPerPage
      window.downloadedPdf = true
      this.showGenerating = false
    },
    downloadPDF() {
      this.showGenerating = true
      // run in setTimeout to allow the generating to pop up right away
      setTimeout(() => {
        this.generatePDF()
          .save()
          .then(this.afterPDF)
      }, 1)
    },
    downloadExcel() {
      this.showGenerating = true
      const ws = XLSX.utils.aoa_to_sheet([
        this.tableFields.map(field => this.getLabel(field))
      ])
      const widths = {}
      this.tableFields.forEach(
        field => (widths[field.key] = this.getLabel(field).length)
      )
      XLSX.utils.sheet_add_aoa(
        ws,
        this.reportRecords.map(record => {
          const newRecord = []
          this.tableFields.forEach(field => {
            newRecord.push(
              field.formatter(record[field.key], field.key, record, true)
            )
            widths[field.key] = Math.max(
              widths[field.key],
              (
                field.formatter(record[field.key], field.key, record, true) ||
                ''
              ).toString().length
            )
          })
          return newRecord
        }),
        {
          header: this.tableFields.map(field => field.key),
          skipHeader: true,
          origin: -1
        }
      )
      ws['!cols'] = this.tableFields
        .map(field => field.key)
        .map(field => ({ wch: widths[field] }))
      const wb = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(wb, ws)
      XLSX.writeFile(wb, `${this.reportName}.xlsx`)
      this.showGenerating = false
      window.downloadedExcel = true
    },
    handleQueryStringPDF() {
      if (this.chartType != 'table') {
        if (!this.gchartReady) {
          setTimeout(this.handleQueryStringPDF, 100)
          return
        }
      }
      this.downloadPDF()
    },
    gchartReadyEvent() {
      this.gchartReady = true
    },
    afterSave(savedData) {
      this.$set(this, 'savedData', savedData)
      if (this.savedData.savePermissions) {
        if (this.savedData.savePermissions.public) {
          this.publicLink = `${window.location.origin}/metrics/public/${this.savedData.saveId}`
          this.$bvModal.show('public-link-modal')
        }
      }
    },
    publicLinkToClipboard() {
      navigator.clipboard.writeText(this.publicLink)
      this.$bvModal.hide('public-link-modal')
    },
    performAction(record, action) {
      if (action.type == 'link') {
        window.open(action.link.interpolate(record), '_blank')
      } else {
        this.graphql(
          this.buildGraphqlMutation(
            action.mutation,
            [
              {
                name: 'input',
                params: action.params
              }
            ],
            ['clientMutationId'],
            {
              mutationName: `${action.label}_ActionMutation`
            }
          ),
          { record }
        ).then(() => {
          record.actionPerformed = action.label.toLowerCase()
          this.actionPerformedIndex++
        })
      }
    }
  },
  mounted() {
    this.currentChartType = this.chartType || this.chartTypes[0] || 'table'
    window.downloadedPdf = false
    window.downloadedExcel = false
    window.reportDone = true
    if (this.$route.query.save == 'true') {
      setTimeout(() => this.$refs['save-component'].saveResults(), 10)
    }
    if (this.$route.query.pdf == 'true') {
      setTimeout(() => this.handleQueryStringPDF(), 10)
    }
    if (this.$route.query.excel == 'true') {
      setTimeout(() => this.downloadExcel(), 10)
    }
  }
}
</script>

<template>
  <div class="min-100-inline-block">
    <Container
      v-if="(allowDownload || allowSave || allowFavorite) && !inTile"
      class="hide-on-print options-container"
    >
      <template v-slot:header>Report Options</template>
      <template v-slot:content>
        <b-row class="w-100">
          <b-col class="text-center" v-if="chartTypeOptions.length > 1">
            <b-form-group label-for="currentChartType" class="form-field-group">
              <b-input-group>
                <b-form-select
                  v-model="currentChartType"
                  name="currentChartType"
                  :options="chartTypeOptions"
                />
              </b-input-group>
            </b-form-group>
          </b-col>
          <b-col
            class="text-center"
            v-if="
              allowDownload &&
                !reportDetails.disableDownload &&
                (typeof reportDetails.excel == 'undefined' ||
                  reportDetails.excel)
            "
          >
            <b-button class="button" @click="downloadExcel">
              Download to Excel
            </b-button>
          </b-col>
          <b-col
            class="text-center"
            v-if="
              allowDownload &&
                !reportDetails.disableDownload &&
                (typeof reportDetails.pdf == 'undefined' || reportDetails.pdf)
            "
          >
            <b-button @click="downloadPDF" class="button">
              Download as PDF
            </b-button>
          </b-col>
          <b-col class="text-center" v-if="allowSave">
            <b-button class="button" v-b-modal.schedule-report-modal>
              Schedule Report
            </b-button>
          </b-col>
          <b-col class="text-center" v-if="allowSave">
            <b-button class="button" v-b-modal.save-results-modal>
              Save / Share Results
            </b-button>
          </b-col>
          <b-col class="text-center" v-if="allowFavorite">
            <b-button class="button" v-b-modal.save-to-favorites-modal>
              Save to Favorites
            </b-button>
          </b-col>
        </b-row>
      </template>
    </Container>

    <Container class="report-container">
      <template v-slot:header>Report</template>
      <template v-slot:content>
        <div ref="reportDiv">
          <div
            v-if="reportDetails.reportHeader"
            class="text-center report-header"
            v-html="
              reportDetails.reportHeader.interpolate({
                ...reportParameters,
                ...reportRecords[0],
                ...(reportRecords[0].reportInfo || {})
              })
            "
          ></div>
          <div v-if="reportDetails.legend" class="report-legend">
            <template v-for="(legend, legendIndex) in reportDetails.legend">
              <div
                v-if="showHideVIf(legend)"
                :key="legendIndex"
                :class="`text-center report-legend-item text-${legend.type}`"
              >
                {{ legend.text }}
              </div>
            </template>
          </div>
          <div
            v-if="['tile', 'tiles'].includes(currentChartType)"
            class="min-100-inline-block"
          >
            <b-row>
              <template v-for="(tile, tileIndex) in tiles">
                <b-col :key="tileIndex" :cols="inTile ? 12 : tile.width">
                  <Tile :tile="tile" :record="reportRecords[0]" />
                </b-col>
              </template>
            </b-row>
          </div>
          <div
            v-else-if="['table', 'simpleTable'].includes(currentChartType)"
            class="min-100-inline-block"
          >
            <b-row
              class="1-100 hide-on-print"
              v-if="currentChartType != 'simpleTable'"
            >
              <b-col cols="4">
                <b-form-group
                  label-cols-lg="4"
                  label-for="tableFilter"
                  class="form-field-group hide-on-print"
                  label-class="font-weight-bold pb-0"
                  label="Filter"
                  v-if="tableFieldRows.length == 1 && reportDetails.tableFilter"
                >
                  <b-input-group>
                    <b-form-input
                      v-model="tableFilter"
                      name="tableFilter"
                      autocomplete="off"
                    />
                  </b-input-group>
                </b-form-group>
              </b-col>
              <b-col cols="4">
                <b-pagination
                  v-model="resultsCurrentPage"
                  :total-rows="reportRecords.length"
                  :per-page="resultsPerPage"
                  align="center"
                  first-number
                  last-number
                  prev-text="<"
                  next-text=">"
                  ellipsis-text="..."
                  class="m-0"
                  size="sm"
                  pills
                  v-if="
                    reportRecords.length > resultsPerPage &&
                      tableFieldRows.length == 1
                  "
                />
              </b-col>
              <b-col cols="4">
                <b-form-group
                  label-cols-lg="6"
                  label-for="resultsPerPage"
                  class="form-field-group hide-on-print"
                  label-class="font-weight-bold pb-0"
                  label="Results Per Page"
                  v-if="reportRecords.length > 10 && tableFieldRows.length == 1"
                >
                  <b-input-group>
                    <b-form-select
                      v-model="resultsPerPage"
                      name="resultsPerPage"
                      :options="[10, 25, 50, 100, 250, 500, 1000]"
                    />
                  </b-input-group>
                </b-form-group>
              </b-col>
            </b-row>
            <b-table
              v-if="
                tableData.length &&
                  tableFieldRows.length == 1 &&
                  currentChartType != 'simpleTable'
              "
              striped
              hover
              :fields="tableFields"
              :items="tableData"
              :per-page="resultsPerPage"
              :current-page="resultsCurrentPage"
              class="w-100"
              :filter="tableFilter"
              @sort-changed="resultsCurrentPage = 1"
            >
              <template v-slot:cell(actionPerformed)="data">
                <div :key="actionPerformedIndex">
                  <template
                    v-for="(action, actionIndex) in reportFields.find(
                      field => field.key == 'actionPerformed'
                    ).actions"
                  >
                    <font-awesome-icon
                      class="action-icon"
                      :icon="action.icon"
                      :key="`${actionIndex}`"
                      :title="action.label"
                      @click="performAction(data.item, action)"
                      v-if="showHideVIf(action, data.item)"
                    />
                  </template>
                </div>
              </template>
            </b-table>
            <b-table-simple v-else-if="tableData.length" class="w-100">
              <b-thead head-variant="dark">
                <b-tr v-for="(row, rowIndex) in tableFieldRows" :key="rowIndex">
                  <b-th
                    v-for="(field, fieldIndex) in row"
                    :key="fieldIndex"
                    :rowspan="field.rows"
                    :colspan="field.cols"
                    :class="field.class"
                  >
                    {{ getLabel(field) }}
                  </b-th>
                </b-tr>
              </b-thead>
              <b-tbody>
                <template v-for="(record, recordIndex) in tableData">
                  <b-tr
                    v-for="(row, rowIndex) in tableFieldRows"
                    :key="`${recordIndex}_${rowIndex}`"
                    :class="{
                      odd: recordIndex % 2 == 0,
                      even: recordIndex % 2 == 1
                    }"
                  >
                    <!-- using td instead of b-td for performance -->
                    <td
                      v-for="(field, fieldIndex) in row"
                      :key="fieldIndex"
                      :rowspan="field.rows"
                      :colspan="field.cols"
                      :class="
                        `${field.class} ${
                          record._cellVariants[field.key || field]
                        }`
                      "
                    >
                      <div
                        v-html="
                          field.formatter(
                            record[field.key || field],
                            field.key || field,
                            record
                          )
                        "
                      ></div>
                    </td>
                  </b-tr>
                </template>
              </b-tbody>
            </b-table-simple>
          </div>
          <GChart
            v-else-if="gchartType"
            :type="gchartType"
            :data="gchartData"
            :options="gchartOptions"
            :settings="gchartSettings"
            class="google-chart"
            @ready="gchartReadyEvent"
          />
          <div
            v-if="reportDetails.reportFooter"
            class="text-center report-footer"
            v-html="
              reportDetails.reportFooter.interpolate({
                ...reportParameters,
                ...reportRecords[0],
                ...(reportRecords[0].reportInfo || {})
              })
            "
          ></div>
        </div>
      </template>
    </Container>
    <ReportSave
      ref="save-component"
      :reportName="reportName"
      :reportParameters="reportParameters"
      :reportFields="reportFields"
      :reportRecords="reportRecords"
      :chartType="chartTypeOptions.length > 1 ? currentChartType : null"
      :savedData="savedData"
      @report-saved="afterSave"
    />
    <ReportFavorite
      :reportName="reportName"
      :reportParameters="reportParameters"
      :chartType="chartTypeOptions.length > 1 ? currentChartType : null"
    />
    <ReportSchedule
      :reportName="reportName"
      :reportParameters="reportParameters"
      :chartType="chartTypeOptions.length > 1 ? currentChartType : null"
    />
    <b-modal id="public-link-modal" title="Public Sharing Link" :ok-only="true">
      {{ publicLink }}
      <b-button class="button ml-3" @click="publicLinkToClipboard">
        Copy to Clipboard
      </b-button>
    </b-modal>
  </div>
</template>

<style>
.report-header {
  font-size: 1.5rem;
  font-weight: bold;
  line-height: 1.65rem;
}
.report-legend {
  margin-top: 20px;
  margin-bottom: 20px;
  line-height: 1.15rem;
  font-size: 0.9rem;
}
.report-footer {
  font-size: 0.9rem;
  line-height: 1.15rem;
}
td.danger {
  background-color: #f5c6cb;
}
td.primary {
  background-color: #b8daff;
}
td.success {
  background-color: #c3e6cb;
}
td.warning {
  background-color: #ffeeba;
}
tr.odd {
  background-color: rgba(0, 0, 0, 0.05);
}
tr,
td,
th {
  page-break-inside: avoid !important;
  page-break-after: auto;
  page-break-before: auto;
}
.min-100-inline-block {
  min-width: 100%;
  display: inline-block;
}
.google-chart {
  min-height: 500px;
  min-width: 750px;
  width: 100%;
}
.google-chart * {
  font-size: unset;
  font-family: unset;
}
.action-icon {
  font-size: 1.35rem;
  margin-right: 5px;
}
</style>
